module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/object/create.js
// module id = ../node_modules/@babel/runtime/core-js/object/create.js
// module chunks = 0